// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .username{
    font-size:10px;
    display: flex;
    flex-direction: column;
    align-self: flex-end;
    color:blue;
    font-weight:700;
    text-align:right;
  }
  .login{
    background-image:url("https://img.freepik.com/free-photo/abstract-grunge-decorative-relief-navy-blue-stucco-wall-texture-wide-angle-rough-colored-background_1258-28311.jpg?w=2000");
    height:auto;
    width:auto;
    background-size:cover;
    background-repeat:repeat-y;
    background-position-y:-60px
  }
  
  
  .insidelogin{
    background-color:black;
    filter:opacity(0.7);
    color:whitesmoke;
    justify-content:center;
    justify-items:center;
    text-align:center;
    padding:1rem;
    margin:3rem;
    border-radius:1rem;
  }
  .AI{
    display: flex;
    flex-direction: column;
    margin-left: 21px;
      margin-top: 10px;
      margin-right: 14px;
  }
  .sentmess{
    align-self: flex-end; /* Align sent messages to the right */
    text-align: left;
    background-color: orange;
    color: black;
    margin-bottom: 12px;
    margin-top: 12px;
    border-radius: 5px;
    padding: 10px;
    width: fit-content;
    max-width:80%;
  }
  .reply{
     align-self: flex-start; /* Align received messages to the left */
    text-align: left;
    background-color: #24b724;
    color: black;
    margin-bottom: 12px;
    margin-top: 12px;
    border-radius: 5px;
    padding: 10px;
    width: fit-content;
    max-width:80%;
  }
  .chatbox{
    display: flex ;
    flex-direction:column;
  color: white;
  /* background-image: url("https://img.freepik.com/free-photo/abstract-grunge-decorative-relief-navy-blue-stucco-wall-texture-wide-angle-rough-colored-background_1258-28311.jpg?w=2000"); */
      background-color: rgb(239, 239, 239);
    overflow-y: scroll;
    height: 90vh;
    position:space-between;
    width:100%;
    padding-bottom:5rem;
   
  }
  
  
 
  
    .messagebox {
          margin: 1vw;
          height: auto;
          width: 80vw;
          border-radius: 3rem;
          resize: vertical;
        }
        .buttonsub {
          margin: 1vw;
          height: 6vh;
          width: 10vw;
          background-image: url('https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Telegram_2019_Logo.svg/1200px-Telegram_2019_Logo.svg.png');
          background-size: contain;
          background-repeat: no-repeat;
          text-align: center;
          background-position: center;
          border: 0 none;
          background-color: transparent;
        }
        .input-container1 {
          display: inline-flex;
          position: fixed;
          bottom: 0;
          width: 100%;
          padding:0.5rem;
           background-color: grey;
        }
  
  
  #w-input-container {
    position: flex-start;
    bottom: 0;
    width: 70%;
    min-height: 20px;
    box-sizing: border-box;
    padding: 9px 18px 11px;
    margin: 5px 10px;
    background-color: #fff;
    border: 1px solid #fff;
    border-radius: 21px;
  }
  
  
  .w-input-text-group {
    position: relative;
  }
  
  
  .w-placeholder {
    color: #a0a0a0;
    top: 0;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    position: absolute;
    opacity: 0;
    transition: 0.2s padding ease-in-out;
  }
  
  
  #w-input-text {
    overflow-x: hidden;
    overflow-y: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    z-index: 1;
    max-height: 100px;
    min-height: 20px;
    padding: 0 0 0 2px;
    outline: 0;
    transition: 0.2s padding ease-in-out;
  }
  
  
  #w-input-text:empty + .w-placeholder {
    opacity: 1;
  }
  
  
  #w-input-text:focus + .w-placeholder {
    padding: 0 6px 0px;
  }
  
  
  #w-input-text:focus {
    padding: 0 6px 0px;
  }`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/Grievance/tc.css"],"names":[],"mappings":";EACE;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oLAAoL;IACpL,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,0BAA0B;IAC1B;EACF;;;EAGA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;MACf,gBAAgB;MAChB,kBAAkB;EACtB;EACA;IACE,oBAAoB,EAAE,qCAAqC;IAC3D,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,aAAa;EACf;EACA;KACG,sBAAsB,EAAE,wCAAwC;IACjE,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,cAAc;IACd,qBAAqB;EACvB,YAAY;EACZ,2LAA2L;MACvL,oCAAoC;IACtC,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,mBAAmB;;EAErB;;;;;IAKE;UACM,WAAW;UACX,YAAY;UACZ,WAAW;UACX,mBAAmB;UACnB,gBAAgB;QAClB;QACA;UACE,WAAW;UACX,WAAW;UACX,WAAW;UACX,2IAA2I;UAC3I,wBAAwB;UACxB,4BAA4B;UAC5B,kBAAkB;UAClB,2BAA2B;UAC3B,cAAc;UACd,6BAA6B;QAC/B;QACA;UACE,oBAAoB;UACpB,eAAe;UACf,SAAS;UACT,WAAW;UACX,cAAc;WACb,sBAAsB;QACzB;;;EAGN;IACE,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;EACrB;;;EAGA;IACE,kBAAkB;EACpB;;;EAGA;IACE,cAAc;IACd,MAAM;IACN,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,oCAAoC;EACtC;;;EAGA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,oCAAoC;EACtC;;;EAGA;IACE,UAAU;EACZ;;;EAGA;IACE,kBAAkB;EACpB;;;EAGA;IACE,kBAAkB;EACpB","sourcesContent":["\r\n  .username{\r\n    font-size:10px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-self: flex-end;\r\n    color:blue;\r\n    font-weight:700;\r\n    text-align:right;\r\n  }\r\n  .login{\r\n    background-image:url(\"https://img.freepik.com/free-photo/abstract-grunge-decorative-relief-navy-blue-stucco-wall-texture-wide-angle-rough-colored-background_1258-28311.jpg?w=2000\");\r\n    height:auto;\r\n    width:auto;\r\n    background-size:cover;\r\n    background-repeat:repeat-y;\r\n    background-position-y:-60px\r\n  }\r\n  \r\n  \r\n  .insidelogin{\r\n    background-color:black;\r\n    filter:opacity(0.7);\r\n    color:whitesmoke;\r\n    justify-content:center;\r\n    justify-items:center;\r\n    text-align:center;\r\n    padding:1rem;\r\n    margin:3rem;\r\n    border-radius:1rem;\r\n  }\r\n  .AI{\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-left: 21px;\r\n      margin-top: 10px;\r\n      margin-right: 14px;\r\n  }\r\n  .sentmess{\r\n    align-self: flex-end; /* Align sent messages to the right */\r\n    text-align: left;\r\n    background-color: orange;\r\n    color: black;\r\n    margin-bottom: 12px;\r\n    margin-top: 12px;\r\n    border-radius: 5px;\r\n    padding: 10px;\r\n    width: fit-content;\r\n    max-width:80%;\r\n  }\r\n  .reply{\r\n     align-self: flex-start; /* Align received messages to the left */\r\n    text-align: left;\r\n    background-color: #24b724;\r\n    color: black;\r\n    margin-bottom: 12px;\r\n    margin-top: 12px;\r\n    border-radius: 5px;\r\n    padding: 10px;\r\n    width: fit-content;\r\n    max-width:80%;\r\n  }\r\n  .chatbox{\r\n    display: flex ;\r\n    flex-direction:column;\r\n  color: white;\r\n  /* background-image: url(\"https://img.freepik.com/free-photo/abstract-grunge-decorative-relief-navy-blue-stucco-wall-texture-wide-angle-rough-colored-background_1258-28311.jpg?w=2000\"); */\r\n      background-color: rgb(239, 239, 239);\r\n    overflow-y: scroll;\r\n    height: 90vh;\r\n    position:space-between;\r\n    width:100%;\r\n    padding-bottom:5rem;\r\n   \r\n  }\r\n  \r\n  \r\n \r\n  \r\n    .messagebox {\r\n          margin: 1vw;\r\n          height: auto;\r\n          width: 80vw;\r\n          border-radius: 3rem;\r\n          resize: vertical;\r\n        }\r\n        .buttonsub {\r\n          margin: 1vw;\r\n          height: 6vh;\r\n          width: 10vw;\r\n          background-image: url('https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Telegram_2019_Logo.svg/1200px-Telegram_2019_Logo.svg.png');\r\n          background-size: contain;\r\n          background-repeat: no-repeat;\r\n          text-align: center;\r\n          background-position: center;\r\n          border: 0 none;\r\n          background-color: transparent;\r\n        }\r\n        .input-container1 {\r\n          display: inline-flex;\r\n          position: fixed;\r\n          bottom: 0;\r\n          width: 100%;\r\n          padding:0.5rem;\r\n           background-color: grey;\r\n        }\r\n  \r\n  \r\n  #w-input-container {\r\n    position: flex-start;\r\n    bottom: 0;\r\n    width: 70%;\r\n    min-height: 20px;\r\n    box-sizing: border-box;\r\n    padding: 9px 18px 11px;\r\n    margin: 5px 10px;\r\n    background-color: #fff;\r\n    border: 1px solid #fff;\r\n    border-radius: 21px;\r\n  }\r\n  \r\n  \r\n  .w-input-text-group {\r\n    position: relative;\r\n  }\r\n  \r\n  \r\n  .w-placeholder {\r\n    color: #a0a0a0;\r\n    top: 0;\r\n    pointer-events: none;\r\n    user-select: none;\r\n    position: absolute;\r\n    opacity: 0;\r\n    transition: 0.2s padding ease-in-out;\r\n  }\r\n  \r\n  \r\n  #w-input-text {\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    white-space: pre-wrap;\r\n    word-wrap: break-word;\r\n    z-index: 1;\r\n    max-height: 100px;\r\n    min-height: 20px;\r\n    padding: 0 0 0 2px;\r\n    outline: 0;\r\n    transition: 0.2s padding ease-in-out;\r\n  }\r\n  \r\n  \r\n  #w-input-text:empty + .w-placeholder {\r\n    opacity: 1;\r\n  }\r\n  \r\n  \r\n  #w-input-text:focus + .w-placeholder {\r\n    padding: 0 6px 0px;\r\n  }\r\n  \r\n  \r\n  #w-input-text:focus {\r\n    padding: 0 6px 0px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
